import { Form, Input, Typography } from "antd";
import React from "react";
import { t } from "i18next";
import { useContext } from "react";
import { StoreContext } from "../../../stores";
import { useState } from "react";
import { idCardItems } from "../../../configs/const";

function IdentificationInfo(props) {
    const { form } = props;
    const { initialForm } = useContext(StoreContext);
    const [data, setData] = useState(
        initialForm?.identification_info
            ? JSON.parse(initialForm?.identification_info)
            : {
                  id_type: "",
                  id_code: "",
                  id_date: "",
                  id_issuer: "",
              }
    );

    return (
        <div className="child_groups">
            {idCardItems.map((item) => (
                <div style={{ marginBottom: 12 }} key={item.key}>
                    <Typography.Text>{t(item.label)}</Typography.Text>
                    <Input
                        onChange={(e) => {
                            setData(Object.assign(data, { [item.key]: e.target.value }));
                            form.setFieldsValue({ identification_info: JSON.stringify(data) });
                        }}
                        value={data[item.key]}
                        size="large"
                    />
                </div>
            ))}
        </div>
    );
}

export default IdentificationInfo;
